import { render, staticRenderFns } from "./educationCurriculumDetail.vue?vue&type=template&id=373f8a1d"
import script from "./educationCurriculumDetail.vue?vue&type=script&lang=js"
export * from "./educationCurriculumDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373f8a1d')) {
      api.createRecord('373f8a1d', component.options)
    } else {
      api.reload('373f8a1d', component.options)
    }
    module.hot.accept("./educationCurriculumDetail.vue?vue&type=template&id=373f8a1d", function () {
      api.rerender('373f8a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCurriculumDetail.vue"
export default component.exports